import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 930px;
	margin: 0 auto;

	padding: 50px 20px;
	color: ${CSSVars.black};

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	.links {
		margin-top: 30px;
		display: grid;
		gap: 30px;
		grid-gap: 30px;
		grid-template-columns: 1fr;
		grid-auto-rows: minmax(auto, fit-content);

		@media screen and (min-width: ${CSSVars.breakpointSM}) {
			grid-template-columns: 1fr 1fr;
		}

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			grid-template-columns: 1fr 1fr 1fr;
		}

		.link {
			border: none;
			padding: 0;
			&:hover {
				background-color: transparent;
				color: ${CSSVars.blue};
			}
		}
	}

	.text-section {
		h3 {
			font-size: ${CSSVars.fontSizeXL};
			margin-bottom: 10px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize2XL};
			}
		}

		.p {
			font-size: ${CSSVars.fontSizeMD};

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}
	}
`;
